import * as React from 'react';
import { Link } from 'react-router-dom';
import { UitkHeading } from 'uitk-react-text';

export interface RoomComponentMobileProps {
  roomCount: any;
  childComponent: any;
}
export class RoomComponentMobile extends React.Component<RoomComponentMobileProps, any> {
  public constructor(props) {
    super(props);
  }

  public render() {
    const { roomCount } = this.props;

    return (
      <>
        <div className="uitk-cell">{this.props.childComponent}</div>
        <div className="uitk-cell all-b-margin-four all-t-margin-three">
          <hr className="dlb-room-separator" />
        </div>
      </>
    );
  }
}
